export default "__VITE_ASSET__18400e39__"